import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { Button } from 'primereact/button';
import { KassenzeichenManagement } from '../../../features/kassenzeichen/kassenzeichenManagement';
import { useDocxDossierTanImport } from '../../../features/kassenzeichen/useDocxDossierTanImport';
import { CreateKassenzeichenRoute } from './neu';
import { Route as ViewKassenzeichenRoute } from './$kassenzeichenId';
import { Route as EditKassenzeichenRoute } from './$kassenzeichenId_.bearbeiten';
import { useNavigate } from '@tanstack/react-router';

function KassenzeichenPage() {
  const navigate = useNavigate();
  const { fileInputRef, isImporting, handleFileChange, triggerFileSelect } =
    useDocxDossierTanImport();

  const view = async (id?: string) => {
    if (!id) return;
    await navigate({
      to: ViewKassenzeichenRoute.fullPath,
      params: { kassenzeichenId: id },
    });
  };

  const edit = async (id?: string) => {
    if (!id) return;
    await navigate({
      to: EditKassenzeichenRoute.fullPath,
      params: { kassenzeichenId: id },
    });
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".docx"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <KassenzeichenManagement
        view={view}
        edit={edit}
        createRoute={CreateKassenzeichenRoute.fullPath}
        additionalActions={
          <Button
            label={isImporting ? 'Importiere...' : 'Import (.docx)'}
            icon="pi pi-upload"
            outlined
            onClick={triggerFileSelect}
            disabled={isImporting}
            loading={isImporting}
          />
        }
      />
    </>
  );
}

export const Route = createFileRoute('/auswahlfelder/kassenzeichen/')({
  component: KassenzeichenPage,
  beforeLoad: choicesReadGuard,
});

export const KassenzeichenRoute = Route;
